import { Box } from 'braid-design-system';
import React, { type ReactNode } from 'react';

import * as styles from './styles.css';

interface Props {
  children: ReactNode;
}

export const ScrollableCard = React.forwardRef(
  ({ children }: Props, ref: React.ForwardedRef<HTMLElement>) => (
    <Box
      className={[styles.maxHeight700, styles.overflowY]}
      ref={ref}
      position="relative"
      background="surface"
      padding="gutter"
      borderRadius="large"
      boxShadow="borderNeutralLight"
      textAlign="left"
    >
      {children}
    </Box>
  ),
);
